<div class="pdf-wrapper" *ngIf="pdfUrl">
  <div class="pdf-toolbar">
    <div class="container container-lg d-flex justify-content-end p-0">
      <button
        (click)="downloadPdf()"
        class="btn btn-lg btn-primary loading-button"
      >
        {{ 'SHARED.DOWNLOAD-PDF' | translate }}
      </button>
    </div>
  </div>

  <div class="pdf-container">
    <pdf-viewer
      [src]="pdfUrl"
      [render-text]="true"
      [autoresize]="true"
      class="pdf-viewer"
    />
  </div>

  <div *ngIf="errorMessage" class="pdf-error">
    {{ errorMessage }}
  </div>
</div>
